import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
export const employeeGuard: CanActivateFn = () => {
  const router = inject(Router);
  return authState(inject(Auth)).pipe(
    take(1),
    map((user) =>
      user
        ? true
        : router.createUrlTree(['/login'], {
            queryParams: { redirectUrl: '/employee' },
          }),
    ),
  );
};
